import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Navigation from "./components/Navigation";
import Add from "./components/pages/Add";
import Edit from "./components/pages/Edit";
import Home from "./components/pages/Home";

function App() {
  return (
    <Router>
      <Navigation />
      <div className="container relative">
        <Routes>
          <Route path="/" element={<Navigate replace to="/tasks" />} />
          <Route path="/tasks" element={<Home />} />
          <Route path="/tasks/add" element={<Add />} />
          <Route path="/tasks/edit/:taskId" element={<Edit />} />
        </Routes>
      </div>

    </Router>
  );
}

export default App;
